'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package
 * @restrict E
 *
 * @description
 * #directive
 * Not implemented : directive used to refresh in the enventuallity that the api is not fast enough to refresh on
 * each changes
 *
 * @template:'<div class="v-action-buttons"><button type="button" class="{{$ctrl.btnTheme}} icon-refresh"><small data-translate="CART.REFRESH_CART"></small></button></div>'
 * @param {string} btnTheme A class to add to the button to apply a specific style theme
 */

angular.module('v-tv-package').component('vTvPackageBtnRefreshBasket', {
    bindings: {
        btnTheme: '@'
    },
    template:'<div class="v-action-buttons"><button type="button" class="{{$ctrl.btnTheme}} icon-refresh"><small data-translate="CART.REFRESH_CART"></small></button></div>'
});